module.exports = __webpack_public_path__ + "static/media/MK_image.0345d3d9.mp3";